module.exports = __webpack_public_path__ + "assets/images/JMDBOX20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDBOX20.png
// module id = 1396
// module chunks = 1